import { Box, Typography } from "@mui/material"
import type { ReactElement, ReactNode } from "react"

interface PageHeaderProps {
  children?: ReactNode
  title: string
}

export const PageHeader = ({ children, title }: PageHeaderProps): ReactElement => {
  return (
    <Box className='flex items-center justify-between pb-8'>
      <Typography variant='h5' color='primary' fontWeight='normal'>
        {title}
      </Typography>
      {children}
    </Box>
  )
}
